import { render, staticRenderFns } from "./DescriptionWithSpellCheck.vue?vue&type=template&id=b8291a0e&scoped=true"
import script from "./DescriptionWithSpellCheck.vue?vue&type=script&lang=js"
export * from "./DescriptionWithSpellCheck.vue?vue&type=script&lang=js"
import style0 from "./DescriptionWithSpellCheck.vue?vue&type=style&index=0&id=b8291a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8291a0e",
  null
  
)

export default component.exports